import { emitAuthTrace } from './authTraceClient';

const resolveErrorMessage = (error: unknown): string =>
  error instanceof Error ? error.message : String(error);

export const traceWebAuthTokenResolutionCompleted = (input: {
  userId: string | null;
  durationMs: number;
  attemptCount: number;
  skipCache: boolean;
  tokenResolved: boolean;
  tokenChanged: boolean | null;
  tokenLength: number | null;
  signatureSuffix: string | null;
  subject: string | null;
  issuedAtMs: number | null;
  expiresAtMs: number | null;
  issuedAgoMs: number | null;
  expiresInMs: number | null;
}): void => {
  emitAuthTrace({
    event: 'web_auth_token_resolution_completed',
    userId: input.userId,
    detail: {
      durationMs: input.durationMs,
      attemptCount: input.attemptCount,
      skipCache: input.skipCache,
      tokenResolved: input.tokenResolved,
      tokenChanged: input.tokenChanged,
      tokenLength: input.tokenLength,
      signatureSuffix: input.signatureSuffix,
      subject: input.subject,
      issuedAtMs: input.issuedAtMs,
      expiresAtMs: input.expiresAtMs,
      issuedAgoMs: input.issuedAgoMs,
      expiresInMs: input.expiresInMs,
    },
  });
};

export const traceWebAuthBootstrapRequestStarted = (input: {
  userId: string | null;
  attempt: number;
  allowProvisioning: boolean;
}): void => {
  emitAuthTrace({
    event: 'web_auth_bootstrap_request_started',
    userId: input.userId,
    detail: {
      attempt: input.attempt,
      allowProvisioning: input.allowProvisioning,
    },
  });
};

export const traceWebAuthBootstrapRequestCompleted = (input: {
  userId: string | null;
  attempt: number;
  allowProvisioning: boolean;
  durationMs: number;
}): void => {
  emitAuthTrace({
    event: 'web_auth_bootstrap_request_completed',
    userId: input.userId,
    detail: {
      attempt: input.attempt,
      allowProvisioning: input.allowProvisioning,
      durationMs: input.durationMs,
    },
  });
};

export const traceWebAuthBootstrapRequestRecovered = (input: {
  userId: string | null;
  attempt: number;
  recoveryReason: 'missing_user_identity' | 'user_not_found';
  durationMs: number;
}): void => {
  emitAuthTrace({
    event: 'web_auth_bootstrap_request_recovered',
    userId: input.userId,
    detail: {
      attempt: input.attempt,
      recoveryReason: input.recoveryReason,
      durationMs: input.durationMs,
    },
  });
};

export const traceWebAuthBootstrapRequestFailed = (input: {
  userId: string | null;
  attempt: number;
  allowProvisioning: boolean;
  durationMs: number;
  error: unknown;
}): void => {
  emitAuthTrace({
    event: 'web_auth_bootstrap_request_failed',
    userId: input.userId,
    detail: {
      attempt: input.attempt,
      allowProvisioning: input.allowProvisioning,
      durationMs: input.durationMs,
      error: resolveErrorMessage(input.error),
    },
  });
};

export const traceWebAuthLoadClerkSessionCompleted = (input: {
  userId: string | null;
  durationMs: number;
  outcome: 'no_token' | 'success' | 'recovered' | 'failed';
}): void => {
  emitAuthTrace({
    event: 'web_auth_load_clerk_session_completed',
    userId: input.userId,
    detail: {
      durationMs: input.durationMs,
      outcome: input.outcome,
    },
  });
};
